import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { isExpired } from "react-jwt";
import { useHistory } from "react-router-dom";

const user = window.localStorage.getItem("user");
const isAuthenticated = localStorage.getItem("token") != null;
const token =
  JSON.parse(localStorage.getItem("user")) != null
    ? JSON.parse(localStorage.getItem("user")).access_token
    : "";
const isTokenExpired = isExpired(token);

const Error = ({ children }: any) => {
  const history = useHistory();
  const handleReconnect = () => {
    history.push("/auth");
  };
  const { onOpen, isOpen } = useDisclosure();
  useEffect(() => {
    console.log(window.location.href.includes("/auth"));
    if (isTokenExpired === true) {
      onOpen();
    }
  });
  return (
    <>
      {!window.location.href.includes("/auth") && (
        <Modal
          isOpen={isOpen}
          onClose={() => {
            console.log("Fonction inemplementé");
          }}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Session expiré</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>Votre session est expiré, veillez réconnecter</Text>
            </ModalBody>
            <ModalFooter>
              <Button variant="ghost" onClick={handleReconnect}>
                Réconnecter
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
      {children}
    </>
  );
};

export default Error;
